import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './core/services/auth.service';

import { NgIf } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgIf],
  template: `
    <router-outlet />

    <div *ngIf="auth.loggingOut()" class="signout-overlay">
      <div class="signout-card">
        <span class="cv-spinner" style="width: 32px; height: 32px; border-width: 3px; border-top-color: #0265d2; margin-bottom: 4px;"></span>
        <span class="signout-text">Signing out...</span>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }

    .signout-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(15, 23, 42, 0.7);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
      animation: fade-in 0.2s ease-out;
    }

    .signout-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      padding: 24px 36px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.05);
      animation: scale-up 0.15s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .signout-text {
      color: #0f172a;
      font-weight: 600;
      font-size: 0.95rem;
    }

    @keyframes fade-in {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    @keyframes scale-up {
      from { transform: scale(0.95); opacity: 0; }
      to { transform: scale(1); opacity: 1; }
    }
  `],
})
export class App implements OnInit {
  constructor(public readonly auth: AuthService) {}

  ngOnInit(): void {
    // Only sync session from cookies if not already authenticated via local storage
    if (!this.auth.isAuthenticated()) {
      this.auth.syncSessionFromCookies().subscribe({
        error: (err) => {
          // If credentials are invalid/expired, clear local storage to sync state
          if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
            this.auth.clearSession();
          }
        }
      });
    }
  }
}
